import { Injectable, inject } from '@angular/core';
import { ApiService } from '../../../core/services/api.service';
import { BatteryConfiguration } from '../../../core/models/domain.models';

@Injectable({ providedIn: 'root' })
export class BatteryConfigurationsService {
  private readonly api = inject(ApiService);

  list() {
    return this.api.get<BatteryConfiguration[]>('/api/battery-configurations');
  }

  create(payload: Partial<BatteryConfiguration>) {
    return this.api.post<BatteryConfiguration>('/api/battery-configurations', payload);
  }

  update(id: string, payload: Partial<BatteryConfiguration>) {
    return this.api.patch<BatteryConfiguration>(`/api/battery-configurations/${id}`, payload);
  }

  delete(id: string) {
    return this.api.delete<{ message: string }>(`/api/battery-configurations/${id}`);
  }
}
